import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService } from 'app/core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';
import { PhongHopModel } from '../phong-hop-model/phong-hop.model';

const API_ROOT_URL = environment.ApiRoot + '/phonghop';

@Injectable()
export class PhongHopService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		
			const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
			return this.http.get<any>(API_ROOT_URL + '/PhongHop_List', { 
				headers: httpHeaders,
				params: httpParams
			});
		
	}
	getPhongHopById(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/PhongHop_Detail?Id_Phong=${itemId}`, { headers: httpHeaders});
	}
	deletePhongHop(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/PhongHop_Delete?Id_Phong=${itemId}`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	deletePhongHops(ids: any[] = []): Observable<any> {
		const url = API_ROOT_URL + '/PhongHop_Multi_Delete';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<QueryResultsModel>(url, ids, { headers: httpHeaders} );
	}
	createPhongHop(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhongHopModel>(API_ROOT_URL+'/PhongHop_Insert', item, { headers: httpHeaders });
	}
	updatePhongHop(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhongHopModel>(API_ROOT_URL+'/PhongHop_Update', item, { headers: httpHeaders });
	}
    //#region ***filter***
    getFilterGroup(column: string, url: string): Observable < any > {
        return this.http.get<any>(environment.ApiRoot + url + `${column}`);
    }
}
